import { toast } from "react-toastify";
import { call, put, takeLatest } from "redux-saga/effects";
import { updateMaxBillableCount } from "../http/requests/project-admin";
import { getMaxBillableCount, ProjectAdminType, setVtrackLoader } from "../redux/actions";
import { toastOptions } from "../common/utils/toasterOptions";

function* workerUpdateMaxBillableCountSaga({ payload }) {
  try {
    yield put(setVtrackLoader(true));
    yield call(updateMaxBillableCount, payload.data.projectId, {
      maxBillableCount: payload.data.maxBillableCount
    });
    toast.success("Max Billable Count Updated Successfully", toastOptions);
    yield put(
      getMaxBillableCount({ projectId: payload.data.projectId })
    );
    yield put(setVtrackLoader(false));
  } catch (err) {
    toast.error(err.data.errorMessage, toastOptions);
    yield put(setVtrackLoader(false));
  }
}

export function* updateMaxBillableCountSaga() {
  yield takeLatest(
    ProjectAdminType.UPDATE_MAX_BILLABLE_COUNT,
    workerUpdateMaxBillableCountSaga
  );
}
